import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { IngestLinkResponse } from '@backrs_ui/grow-ui/src/redux/coachLubav/coachLubav.api';

const LINK_STRINGS = appStrings.modules.profile.modalUploader.document.link;

const GOOGLE_SOURCE_KINDS: readonly IngestLinkResponse['source_kind'][] = [
  'native_gdoc',
  'google_drive_binary',
];

export const isValidUrl = (value: string): boolean => {
  try {
    const url = new URL(value.trim());

    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};

export const getUnviewableLinkMessage = (
  result: Pick<IngestLinkResponse, 'unsupported_host' | 'reason' | 'source_kind'>,
  speaker = 'Lubav',
): string => {
  if (result.unsupported_host === 'onedrive') {
    return LINK_STRINGS.unsupportedHost('OneDrive', speaker);
  }

  if (result.unsupported_host === 'canva') {
    return LINK_STRINGS.unsupportedHost('Canva', speaker);
  }

  const isGoogleLink = GOOGLE_SOURCE_KINDS.includes(result.source_kind);

  if (result.reason === 'private' && isGoogleLink) {
    return LINK_STRINGS.privateGoogle(speaker);
  }

  return LINK_STRINGS.unreadable(speaker);
};
